import { fetch, fetchInstance } from 'data-layer/fetch-api/fetch';
import { ProcessPaymentService, ProcessPaymentServiceV2 } from '../services/ProcessPaymentSerivce';

export const processPayment = async (paymentData: any) => {
  try {
    const url = ProcessPaymentService({}).url;
    const { data: responseData } = await fetch(fetchInstance, url, paymentData);
    if (!responseData.success) {
      return { statusMessage: responseData.message || responseData.statusMessage || 'Server returned error.'}
    }
    return responseData.data;
  } catch (err) {
    console.log(err);
  }

  return {};
}

export const processPaymentV2 = async (paymentData: any) => {
  try {
    const url = ProcessPaymentServiceV2({}).url;
    const { data: responseData } = await fetch(fetchInstance, url, paymentData, { apiVersion: 2 });
    if (!responseData.success) {
      return { statusMessage: responseData.message || responseData.statusMessage || 'Server returned error.'}
    }
    return responseData.data;
  } catch (err) {
    console.log(err);
  }

  return {};
}
